import React from 'react'

import { Box, Text } from 'stardust'
import styled from 'styled-components'

import CommentInput from '~/components/CommentInput'
import Modal from '~/components/Modal'
import colors from '~/ui-components/tokens/colors'

import Conversation from './Conversation/Conversation'
import Header from './Header'
import useAssistant from './hooks/useAssistant'
import { AssistModalProps } from './interface'

// Constants for modal dimensions
const MODAL_CONVERSATION_MIN_HEIGHT = (viewportHeight: string) => `calc(${viewportHeight} - 17rem)`
const VIEWPORT_HEIGHT = '100vh'
const VIEWPORT_HEIGHT_BREAKPOINT = '28rem'
const MODAL_HEIGHT = (maxViewportHeight?: string) =>
  `min(${VIEWPORT_HEIGHT_BREAKPOINT}, ${MODAL_CONVERSATION_MIN_HEIGHT(maxViewportHeight || VIEWPORT_HEIGHT)})`
const CONVERSATION_MIN_HEIGHT = MODAL_HEIGHT()
const CONVERSATION_MAX_HEIGHT = `max(${MODAL_HEIGHT(VIEWPORT_HEIGHT_BREAKPOINT)}, ${MODAL_HEIGHT()})`

const OuterBox = styled(Box)`
  width: 1290px;
  max-width: min(-40px + 100vw, -80px + 200vh);
  padding: 20px;
  border-radius: 16px;
`

const FloatingCommentInputBox = styled(Box)`
  position: absolute;
  bottom: 0;
  width: 100%;
`

const AssistModal = (props: AssistModalProps) => {
  const { closeAssistModal } = props
  const { messages, isFetching, handleUserInput, textInputEnabled, handleAssistActionPill } =
    useAssistant(props)

  return (
    <Modal open onClose={closeAssistModal} dontRenderCloseButton>
      <OuterBox bg="surfacePrimary" borderRadius="16px" height="max-content" minWidth="0">
        <Header closeAssistModal={closeAssistModal} />
        <Box mt="12px">
          <Conversation
            messages={messages}
            isFetching={isFetching}
            minHeight={CONVERSATION_MIN_HEIGHT}
            maxHeight={CONVERSATION_MAX_HEIGHT}
            handleAssistActionPill={handleAssistActionPill}
          />
        </Box>
        <Text fontSize="14px" lineHeight="21px" mt={1} ml={2} color={colors.cosmicShade11}>
          AI responses can be inaccurate
        </Text>
        <Box mt="12px" position="relative" height="48px" width="100%">
          <FloatingCommentInputBox>
            <CommentInput
              placeholder="Enter text here"
              addComment={handleUserInput}
              autoFocus
              inlineV3
              disableInput={!textInputEnabled}
            />
          </FloatingCommentInputBox>
        </Box>
      </OuterBox>
    </Modal>
  )
}

AssistModal.displayName = 'AssistModal'
export default React.memo(AssistModal)
